// AUTH-004: Ein bereits angemeldetes Gerät greift nach Erstanmeldung auch
// offline auf lokal verfügbare Daten zu - Sitzungsdaten werden daher lokal
// persistiert (localStorage) und beim Start optimistisch übernommen, ohne
// auf eine Netzwerkantwort zu warten. Eine NEUE Anmeldung ist offline nicht
// möglich (siehe LoginPage: der Login-Request scheitert dann schlicht am
// fehlenden Netzwerk).

export interface AuthUser {
  id: string;
  username: string | null;
  email: string;
  emailVerified: boolean;
  isSystemAdmin: boolean;
  communityOptIn: boolean;
  countryCode: string | null;
  postalCode: string | null;
  city: string | null;
}

export interface AuthState {
  accessToken: string | null;
  refreshToken: string | null;
  user: AuthUser | null;
}

const STORAGE_KEY = 'shoppinglist.auth.v1';

function loadInitial(): AuthState {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return { accessToken: null, refreshToken: null, user: null };
    return JSON.parse(raw) as AuthState;
  } catch {
    return { accessToken: null, refreshToken: null, user: null };
  }
}

let state: AuthState = loadInitial();
const listeners = new Set<() => void>();

function persist(): void {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
  } catch {
    // Privater Modus / Speicher voll: Sitzung bleibt nur im Arbeitsspeicher.
  }
}

function notify(): void {
  for (const l of listeners) l();
}

export const authStore = {
  getState(): AuthState {
    return state;
  },
  subscribe(listener: () => void): () => void {
    listeners.add(listener);
    return () => listeners.delete(listener);
  },
  setSession(accessToken: string, refreshToken: string, user: AuthUser): void {
    state = { accessToken, refreshToken, user };
    persist();
    notify();
  },
  setAccessToken(accessToken: string, refreshToken: string): void {
    state = { ...state, accessToken, refreshToken };
    persist();
    notify();
  },
  setUser(user: AuthUser): void {
    state = { ...state, user };
    persist();
    notify();
  },
  clear(): void {
    state = { accessToken: null, refreshToken: null, user: null };
    persist();
    notify();
  },
};
